import * as axios from '../axios'

import toast from "react-hot-toast";
import Cookies from 'js-cookie';

export const loginActions = (loginRequest) => async (dispatch) => {
  try {
    const message = await axios.login(loginRequest);
    dispatch({ type: "LOGIN", payload: message })
    toast.success(message.data)
    window.location.href = '/';
  } catch (error) {
    toast.error(error.response?.data || 'Bilinmeyen hata');
  }
}

export const registerAction = (registerRequest) => async (dispatch) => {
  try {
    const message = await axios.register(registerRequest)
    dispatch({ type: "REGISTER", payload: message })
    toast.success(message.data)
    window.location.href = '/';
  } catch (error) {
    toast.error(error.response?.data || 'Bilinmeyen hata');
  }
}

export const logoutAction = (setUser) => async (dispatch) => {
  try {
    const message = await axios.logout();
    setUser(null);
    dispatch({ type: "LOGOUT", payload: "Çıkış Yapıldı" })
    toast.success(message.data)
    window.location.href = '/giris-yap';
  } catch (error) {
    toast.error("Çıkış Yaparken Bir Sorun Oluştu!");
  }
}
